import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

const PdfPrinter = ({printHandler, disabledPrint = false}) => {
    return (
        <div className={"p-2 text-right d-print-none pdf-printer"}>
            <button type="button" disabled={disabledPrint} className="btn btn-secondary-lc btn-circle" onClick={printHandler}>
                {/* <FontAwesomeIcon icon={faFilePdf}/><span className="label px-2">PDF</span> */}
                <FontAwesomeIcon icon={faPrint}/>
            </button>
        </div>
    );
};

export default PdfPrinter;